import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Mobil uygulama ile AYNI Firebase projesi (bursa-trabzon-dernegi).
// Web client SDK — getReactNativePersistence GEREKMEZ; tarayıcı otomatik persist eder.
const firebaseConfig = {
  apiKey: "AIzaSyANpVovS89PeUdP5d6HIeUAGdaUZtBVI_k",
  authDomain: "bursa-trabzon-dernegi.firebaseapp.com",
  projectId: "bursa-trabzon-dernegi",
  storageBucket: "bursa-trabzon-dernegi.firebasestorage.app",
  messagingSenderId: "497839622721",
  appId: "1:497839622721:web:c08a9a924c20285c6414c0",
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export default app;
